module.exports = __webpack_public_path__ + "static/media/csusm.f7ab478d.jpg";